import { useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import gsap from "gsap";
import { playHeroIntro } from "../animations/heroAnimations";
import { useLanguage } from "../context/LanguageContext";

export default function Hero({ batRef }) {
  const { t } = useLanguage();

  const container = useRef(null);

  useEffect(() => {
    gsap.from(container.current, {
      opacity: 0,
      y: 40,
      duration: 1.2,
      ease: "power3.out",
    });
  }, []);

  useEffect(() => {
    playHeroIntro();
  }, []);

  const handleViewProjects = () => {
    const tl = gsap.timeline();

    tl.set(batRef.current, {
      opacity: 1,
      x: -400,
      y: -300,
      scale: 0.08,
      rotate: -30,
      filter: "blur(0px)",
    });

    tl.to(batRef.current, {
      x: window.innerWidth + 300,
      y: window.innerHeight + 200,
      scale: 2.2,
      rotate: 20,
      duration: 1.6,
      ease: "power2.inOut",
    });

    tl.to(
      container.current,
      {
        opacity: 0,
        duration: 0.4,
        ease: "power2.out",
      },
      "-=0.8",
    );
  };

  return (
    <section
      id="home"
      className="min-h-screen flex items-center text-white px-24 bg-gradient-to-br from-[#0a0a0a] via-[#12080b] to-black"
    >
      <div ref={container} className="ml-20 max-w-xl text-neutral-200">
        <p className="text-sm mb-4 opacity-80">{t.hero.intro}</p>

        <h1 className="text-6xl font-semibold mb-4">Tatiane</h1>

        <p className="mb-10 opacity-80">{t.hero.role}</p>

        <p className="text-lg italic mb-8">{t.hero.tagline}</p>

        <NavLink to="/projects">
          <button
            id="view-projects"
            className="
            font-serifJojo
            text-lg
            tracking-widest
            uppercase
            relative
            after:absolute
            after:left-0
            after:-bottom-2
            after:w-full
            after:h-[1px]
            after:bg-red-700
            after:scale-x-0
            after:origin-left
            after:transition-transform
            hover:after:scale-x-100
            transition-colors
            hover:text-red-500
          "
            onClick={handleViewProjects}
          >
            → {t.hero.cta}
          </button>
        </NavLink>
      </div>
    </section>
  );
}
